module.exports = __webpack_public_path__ + "img/sprinkle-22.152bcdff.webp";